<template>
<div class="chapter">
<div class="inner_page">
<h3 class="ChTitle" id="ch4"><a id="ch4aa"></a><a id="ch4a"></a><a id="page_18"></a><a href="#/Contents#rch4"><span class="underline">THE TALENTED MISS AMERICA</span></a></h3>
<p class="center1"><span><i>The Miss America Pageant added the talent portion to the contest in 1935. Most contestants sing or dance, but some display more unusual skills.</i></span></p>
<p class="noindent"><span><span class="dropcap">1</span><b>957:</b> Amanda Whitman (Miss Tennessee) did a gymnastic tumbling and trampoline routine to the theme from <i>The Third Man</i>.</span></p>
<p class="noindent1a"><span><b>1959:</b> Elizabeth Holmes (Miss New York) did an impression of French singer and actor Maurice Chevalier. Miss New Jersey, Beverly Ann Domareki, did an impression of a beatnik.</span></p>
<p class="noindent1a"><span><b>1960:</b> Ann Susan Barber (Miss New Jersey) did a comic routine about a hillbilly attending her first baseball game.</span></p>
<p class="noindent1a"><span><b>1961:</b> LaVerda Garrison (Miss Idaho) gave a dramatic reading of Charlotte Perkins Gilman’s feminist short story “The Yellow Wallpaper.”</span></p>
<p class="noindent1a"><span><b>1967:</b> Jane Jayroe (Miss Oklahoma) conducted the orchestra in a rendition of the #2 hit “1-2-3” (and she won the pageant!).</span></p>
<p class="noindent1a"><span><b>1973:</b> Ellen Meade (Miss Florida) did a ballet sequence from <i>Swan Lake…on</i> roller skates.</span></p>
<p class="noindent1a"><span><b>1977:</b> Julie Houston (Miss Alabama) played the banjo. The song: the theme from <i>The Beverly Hillbillies</i>.</span></p>
<p class="noindent1a"><span><b>1981:</b> Angelina Johnson (Miss Tennessee) did impressions of the lead characters from TV’s <i>Laverne and Shirley</i>…with ventriloquist dummies.</span></p>
<p class="noindent1a"><span><b>1982:</b> Laura Matthys (Miss Oregon) twirled a rifle to the tune of a traditional folk march from Herzegovina.</span></p>
<p class="noindent1a"><span><b>1987:</b> Aurelie McCarthy (Miss Massachusetts) played “Hava Nagila” on the marimba.</span></p>
<p class="noindent1a"><span><b>1989:</b> Tammy Kettunen (Miss Arizona) performed a “freestyle roller-skating” routine to “Amazing Grace.”</span></p>
<p class="noindent1a"><span><b>1992:</b> Shannon Boy (Miss Arkansas) played the theme from <i>Star Wars</i> on the flute.</span></p>
<p class="noindent1a"><span><b>2011:</b> Lauren Cheape (Miss Hawaii) performed acrobatic jump roping to the <i>Hawaii Five-O</i> theme.</span></p>
<div class="box">
<p class="center7"><span><b>The expression “in a pickle” was coined by Shakespeare.</b></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter004.vue?6e56715c